const applicationTitles = [
    {
        nodeId: 'customerBasicInformation',
        text: 'Customer Basic Information'
    },
    {
        nodeId: 'assessmentPlaces',
        text: 'Assessment Place',
        children: [
            {
                nodeId:'1_assessmentPlace',
                text:'台東廠',
                children: [
                    {nodeId:'1_survey', text:'Survey'},
                    {nodeId:'1_referenceDocument', text:'Reference Document'},
                    {nodeId:'1_factoryFloorPlan', text:'Factory Floor Plan'},
                    {nodeId:'1_productionLine', text:'Production Line Information'}
                ]
            },
            {
                nodeId:'2_assessmentPlace',
                text:'屏東廠',
                children: [
                    {nodeId:'2_survey', text:'Survey'},
                    {nodeId:'2_referenceDocument', text:'Reference Document'},
                    {nodeId:'2_factoryFloorPlan', text:'Factory Floor Plan'},
                    {nodeId:'2_productionLine', text:'Production Line Information'}
                ]
            }
        ]
    },
    {
        nodeId: 'assessmentProducts',
        text: 'Assessment Product',
        children:[
            {nodeId:'1_assessmentProduct', id:'1', text:'杏仁玄米餅'},
            {nodeId:'2_assessmentProduct', id:'2', text:'Pasta義大利麵'},
            {nodeId:'3_assessmentProduct', id:'3', text:'桂圓四物飲'},
            {nodeId:'4_assessmentProduct', id:'4', text:'Natural Benefits 食安生技-椰子汁'},
            {nodeId:'5_assessmentProduct', id:'5', text:'Natural Benefits 純在-蔬菜綜合果汁'},
            {nodeId:'6_assessmentProduct', id:'6', text:'Natural Benefits 食安生技-芒果綜合果汁'},
            {nodeId:'7_assessmentProduct', id:'7', text:'Natural Benefits 純在葡萄柚蘋果綠茶'}
        ]
    }
]

export default applicationTitles;